import { render, staticRenderFns } from "./notification.vue?vue&type=template&id=55aa9b62&scoped=true"
import script from "./notification.vue?vue&type=script&lang=ts"
export * from "./notification.vue?vue&type=script&lang=ts"
import style0 from "./notification.vue?vue&type=style&index=0&id=55aa9b62&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55aa9b62",
  null
  
)

export default component.exports